import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { pollForSession } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Wait for Appwrite to set the session cookie after OAuth redirect
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Poll for session with retries - this will keep trying to get the session
        const sessionFound = await pollForSession(8, 300);

        if (sessionFound) {
          // User authenticated successfully
          navigate("/admin");
        } else {
          // Session not established, redirect to home
          navigate("/");
        }
      } catch (error) {
        console.error("Error during auth callback:", error);
        navigate("/");
      }
    };

    handleCallback();
  }, [pollForSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <svg className="w-12 h-12 text-accent animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
    </div>
  );
};

export default AuthCallback;
